export const heatDataNew = [
  {
    quarter: "Summer 2018",
    maxTemp: 29.33,
    solarExposure: 19.83,
  },
  {
    quarter: "Autumn 2018",
    maxTemp: 22.43,
    solarExposure: 11.47,
  },
  {
    quarter: "Winter 2018",
    maxTemp: 20.3,
    solarExposure: 13.6,
  },
  {
    quarter: "Spring 2018",
    maxTemp: 26.13,
    solarExposure: 20.37,
  },
  {
    quarter: "Summer 2019",
    maxTemp: 29.4,
    solarExposure: 19.17,
  },
  {
    quarter: "Autumn 2019",
    maxTemp: 21.9,
    solarExposure: 11.3,
  },
  {
    quarter: "Winter 2019",
    maxTemp: 20.3,
    solarExposure: 13.53,
  },
  {
    quarter: "Spring 2019",
    maxTemp: 28.03,
    solarExposure: 23.5,
  },
  {
    quarter: "Summer 2020",
    maxTemp: 27.67,
    solarExposure: 17.1,
  },
  {
    quarter: "Autumn 2020",
    maxTemp: 20.8,
    solarExposure: 10.77,
  },
  {
    quarter: "Winter 2020",
    maxTemp: 19.8,
    solarExposure: 13.13,
  },
  {
    quarter: "Spring 2020",
    maxTemp: 26.17,
    solarExposure: 19.37,
  },
  {
    quarter: "Summer 2021",
    maxTemp: 26.47,
    solarExposure: 17.2,
  },
  {
    quarter: "Autumn 2021",
    maxTemp: 20.7,
    solarExposure: 11.4,
  },
  {
    quarter: "Winter 2021",
    maxTemp: 20.27,
    solarExposure: 13.33,
  },
  {
    quarter: "Spring 2021",
    maxTemp: 24.53,
    solarExposure: 19.4,
  },
  {
    quarter: "Summer 2022",
    maxTemp: 26.5,
    solarExposure: 16.73,
  },
  {
    quarter: "Autumn 2022",
    maxTemp: 20.97,
    solarExposure: 10.93,
  },
  {
    quarter: "Winter 2022",
    maxTemp: 18.93,
    solarExposure: 11.97,
  },
  {
    quarter: "Spring 2022",
    maxTemp: 24.07,
    solarExposure: 21.73,
  },
  {
    quarter: "Summer 2023",
    maxTemp: 28.07,
    solarExposure: 19.63,
  },
  {
    quarter: "Autumn 2023",
    maxTemp: 20.7,
    solarExposure: 11.03,
  },
]
